// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2iMzH","modalFooterButton":"ModalNotes_modalFooterButton__3Wf0-"};